import React from 'react';
import { Box, Container, Skeleton } from '@mui/material';
import StyledBox from 'views/rebranded-module/information-module/ContactUsViewV2/components/ContactUs/ContactUs.styles';

const ContactUsSkeleton = () => (
  <StyledBox>
    <Box className="CUContentContainer">
      <Container maxWidth="xl">
        <Box className="CUWrapper">
          <Skeleton variant="text" width="60%" height={24} sx={{ mb: 2 }} />
          <Skeleton variant="text" width="80%" height={32} sx={{ mb: 1 }} />
          <Skeleton variant="text" width="70%" height={20} sx={{ mb: 4 }} />
          <Box className="CUContactInfoWrapper">
            <Box className="CUCallUsSection">
              <Skeleton variant="text" width="30%" height={24} sx={{ mb: 2 }} />
              <Skeleton variant="rectangular" width="200px" height={40} sx={{ mb: 1, borderRadius: 2 }} />
              <Skeleton variant="rectangular" width="220px" height={40} sx={{ borderRadius: 2 }} />
            </Box>
            <Box className="CUMailUsSection" sx={{ mt: 4 }}>
              <Skeleton variant="text" width="30%" height={24} sx={{ mb: 2 }} />
              <Skeleton variant="text" width="60%" height={20} sx={{ mb: 0.5 }} />
              <Skeleton variant="text" width="50%" height={20} sx={{ mb: 0.5 }} />
              <Skeleton variant="text" width="40%" height={20} sx={{ mb: 0.5 }} />
              <Skeleton variant="text" width="20%" height={20} />
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  </StyledBox>
);

export { ContactUsSkeleton };
